<template>
  <section class="main-section landing-page">
    <!-- Hero -->
    <section id="hero" class="hero-section">
      <div class="hero-bg" aria-hidden="true">
        <div class="hero-grid"></div>
        <div class="hero-glow hero-glow--left"></div>
        <div class="hero-glow hero-glow--right"></div>
      </div>
      <div class="container hero-inner" data-aos="fade-up">
        <div class="hero-badge">
          <span class="live-dot"></span>
          SWISS TRADING SYSTEM
        </div>
        <h1 class="hero-title">
          Precisão Suiça.<br>
          Trading com confiança, <span class="hero-title-accent">feito para você.</span>
        </h1>
        <p class="hero-description">
          Bem-vindo a Comunidade SWISS - um ecossistema institucional para aprender, operar e evoluir com ferramentas de precisão, educacão e suporte premium.
        </p>
        <div class="hero-stats">
          <div class="stat-pill">
            <span class="stat-label">Plataformas</span>
            <span class="stat-value">4+</span>
          </div>
          <div class="stat-pill">
            <span class="stat-label">Indicadores</span>
            <span class="stat-value">Pro</span>
          </div>
          <div class="stat-pill">
            <span class="stat-label">Suporte</span>
            <span class="stat-value">24/7</span>
          </div>
        </div>
        <div class="hero-actions">
          <button type="button" class="btn btn-primary" @click="scrollToSection('planos')">Ver planos</button>
          <button type="button" class="btn btn-ghost" @click="scrollToSection('ferramentas')">Explorar tecnologia</button>
        </div>
      </div>
    </section>

    <!-- Nova ferramenta -->
    <section id="nova-ferramenta" class="preview-section section-block section-block--alt">
      <div class="container">
        <div class="section-head" data-aos="fade-up">
          <p class="section-kicker">Em breve</p>
          <h2 class="section-title">Nossa mais nova ferramenta</h2>
          <p class="section-description">
            Agora estamos lado a lado com as grandes instituições, mapeando eles em ações, opções e futuros.
          </p>
        </div>
        <div class="preview-dashboards">
          <div class="preview-dashboard-item" data-aos="fade-right">
            <img src="/img/dash1.jpg" alt="Preview da nova ferramenta Swiss Money" class="preview-dashboard-image">
          </div>
          <div class="preview-dashboard-item" data-aos="fade-left">
            <img src="/img/dash2.jpg" alt="Dashboard institucional Swiss Money" class="preview-dashboard-image">
          </div>
        </div>
      </div>
    </section>

    <!-- Ecossistema -->
    <section id="ferramentas" class="ecosystem-section section-block">
      <div class="container">
        <div class="section-head">
          <p class="section-kicker">O Ecossistema</p>
          <h2 class="section-title">Soluções exclusivas para traders premium</h2>
          <p class="section-description">Trading com confiança, feito para você. Resultados consistentes, sem perder a simplicidade.</p>
        </div>
        <div class="ecosystem-cards">
          <div class="ecosystem-card" data-aos="fade-up" data-aos-delay="0">
            <div class="card-icon">
              <i class="fas fa-chart-line"></i>
            </div>
            <h3 class="card-title">Indicadores Exclusivos</h3>
            <p class="card-description">Tecnologia Inteligente, Mapeando as zonas de interesse e as regiões de posicionamento institucional.</p>
          </div>
          <div class="ecosystem-card" data-aos="fade-up" data-aos-delay="100">
            <div class="card-icon">
              <i class="fas fa-graduation-cap"></i>
            </div>
            <h3 class="card-title">Educação Personalizada</h3>
            <p class="card-description">Estudos e ensinamentos voltados para o seu desenvolvimento profissional como trader.</p>
          </div>
          <div class="ecosystem-card coming-soon card-robot" data-aos="fade-up" data-aos-delay="200">
            <div class="card-robot-header">
              <!--<span class="coming-soon-badge badge-left">EM BREVE</span>
              <a href="#" class="card-link">Saiba mais</a>-->
            </div>
            <h3 class="card-title">Estratégias Automatizadas</h3>
            <div class="card-video-wrapper">
              <video class="card-video" muted loop playsinline autoplay>
                <source src="/img/YAN-divulg.mp4" type="video/mp4">
              </video>
            </div>
            <p class="card-description">Algoritmos de alta performance</p>
          </div>
          <div class="ecosystem-card coming-soon" data-aos="fade-up" data-aos-delay="300">
            <span class="coming-soon-badge badge-right">EM BREVE</span>
            <div class="card-icon">
              <i class="fas fa-users"></i>
            </div>
            <h3 class="card-title">Copy Trade</h3>
            <p class="card-description">Diversifique seu capital seguindo operações validadas por profissional direto da Europa.</p>
          </div>
        </div>
      </div>
    </section>

    <!-- Ferramentas -->
    <section class="tools-section section-block section-block--alt">
      <div class="container">
        <div class="section-head">
          <p class="section-kicker">Tecnologia visual</p>
          <h2 class="section-title">Ferramentas exclusivas</h2>
          <p class="section-description">Engenharia de cálculos avançados para validar decisões. Menos ruído, mais assertividade no trading.</p>
        </div>
        <div class="platforms-carousel-wrapper">
          <div class="platforms-marquee" aria-label="Plataformas parceiras">
            <div class="platforms-marquee-track">
              <div
                v-for="(platform, index) in platformsMarqueeSlides"
                :key="`platform-${index}`"
                class="platform-slide"
                :aria-hidden="index >= platformCarouselCount ? 'true' : undefined"
              >
                <div class="platform-card">
                  <p class="platform-card-name">{{ platform.name }}</p>
                  <img :src="platform.img" :alt="platform.name" class="platform-logo">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="charts-grid">
          <div class="chart-item" v-for="i in 6" :key="i" data-aos="fade-up" :data-aos-delay="(i-1) * 100">
            <img :src="`/img/indicator-${i}.png`" alt="Grafico" class="chart-image" />
          </div>
        </div>
      </div>
    </section>

    <!-- Track Record -->
    <section id="resultados" class="track-record-section section-block">
      <div class="container">
        <div class="section-head">
          <p class="section-kicker">Performance</p>
          <h2 class="section-title">Track Record</h2>
          <p class="section-subtitle">Números não mentem.</p>
          <p class="section-description">Metodologia validada todos os dias no mercado real.</p>
        </div>
        <div class="track-record-content">
          <div class="track-item" data-aos="fade-right">
            <img src="/img/result-1.png" alt="Resultado 1" class="result-image" />
          </div>
          <div class="track-item" data-aos="fade-left">
            <img src="/img/result-2.png" alt="Resultado 2" class="result-image" />
          </div>
        </div>
          <!--<button class="btn-secondary">Ver Relatorios Completos</button>-->
      </div>
    </section>

    <!-- Indicou Ganhou Section -->
    <section class="indicou-ganhou-section">
      <div class="container">
        <div class="indicou-ganhou-banner" data-aos="fade-up">
          <i class="fas fa-gift indicou-ganhou-icon"></i>
          <h2 class="indicou-ganhou-title">INDICOU GANHOU</h2>
          <p class="indicou-ganhou-message">A cada 2 indicações, ganhe 1 mês de assinatura grátis.</p>
          <p class="indicou-ganhou-disclaimer">**Válido apenas para membros do Club SWISS</p>
        </div>
      </div>
    </section>

    <!-- Planos -->
    <section id="planos" class="plans-section section-block section-block--alt">
      <div class="container">
        <div class="section-head">
          <p class="section-kicker">Assinaturas</p>
          <h2 class="section-title">Escolha seu plano</h2>
          <p class="section-subtitle">Planos por plataforma, com condições para segunda assinatura.</p>
        </div>

        <template v-if="activeProducts.length > 0">
          <!-- Abas Plataformas -->
          <div class="plans-platform-tabs">
            <button
              v-for="(prod, idx) in activeProducts"
              :key="prod.id"
              type="button"
              class="platform-tab"
              :class="{ active: selectedPlatformIndex === idx }"
              @click="selectedPlatformIndex = idx; selectedPeriodIndex = 0"
            >
              {{ platformLabel(prod.platform) || prod.name }}
            </button>
          </div>

          <div class="plans-content">
            <!-- Coluna esquerda: periodos -->
            <div class="plans-periods">
              <div
                v-for="(per, pIdx) in (selectedProduct && selectedProduct.periods) || []"
                :key="per.id"
                type="button"
                class="period-item"
                :class="{ active: selectedPeriodIndex === pIdx }"
                @click="selectedPeriodIndex = pIdx"
              >
                <div class="period-item-name">{{ per.periodName || per.period_name }}</div>
                <div class="period-item-prices">
                  <span v-if="(!showUsd || (showUsd && !(per.priceUsd != null && per.priceUsd > 0))) && per.price != null && per.price > 0">
                    <template v-if="per.promotion && (per.type === 'percent' || per.type === 'fixed')">
                      <span class="period-price-old">R$ {{ formatPrice(per.price) }}</span>
                      <span class="period-price-promo">R$ {{ formatPrice(promotionPrice(per)) }}</span>
                    </template>
                    <template v-else>
                      <span class="period-price">R$ {{ formatPrice(per.price) }}</span>
                    </template>
                  </span>
                  <span v-if="showUsd && per.priceUsd != null && per.priceUsd > 0" class="period-usd">
                    <template v-if="per.promotion && (per.type === 'percent' || per.type === 'fixed')">
                      <span class="period-price-old">US$ {{ formatPriceUsd(per.priceUsd) }}</span>
                      <span class="period-price-promo">US$ {{ formatPriceUsd(promotionPriceUsd(per)) }}</span>
                    </template>
                    <template v-else>
                      <span class="period-price">US$ {{ formatPriceUsd(per.priceUsd) }}</span>
                    </template>
                  </span>
                </div>
                <div v-if="per.promotion && per.expiration" class="period-item-validity">Válido até {{ per.expiration }}</div>
                <div v-if="getSecondSubscriptionDiscount(per) > 0" class="period-item-second-sub">
                  2a assinatura: {{ getSecondSubscriptionDiscount(per) }}% de desconto
                  <span v-if="(!showUsd || !(per.priceUsd != null && per.priceUsd > 0)) && per.price != null && per.price > 0">
                    (R$ {{ formatPrice(secondSubscriptionPriceBrl(per)) }})
                  </span>
                  <span v-else-if="showUsd && per.priceUsd != null && per.priceUsd > 0">
                    (US$ {{ formatPriceUsd(secondSubscriptionPriceUsd(per)) }})
                  </span>
                </div>
              </div>
            </div>

            <!-- Coluna direita: descritivo + botao -->
            <div class="plans-detail">
              <div v-if="selectedProduct && selectedPeriod" class="plan-detail-card">
                <div class="plan-detail-header">
                  <h3 class="plan-detail-platform">{{ platformLabel(selectedProduct.platform) || selectedProduct.name }}</h3>
                  <img v-if="platformLogo(selectedProduct.platform)" :src="platformLogo(selectedProduct.platform)" :alt="platformLabel(selectedProduct.platform)" class="plan-detail-logo" />
                </div>
                <p v-if="selectedProduct.desc" class="plan-detail-desc">{{ selectedProduct.desc }}</p>
                <p class="plan-detail-period">{{ selectedPeriod.periodName || selectedPeriod.period_name }}</p>
                <p class="plan-detail-desc">{{ selectedPeriod.description }}</p>
                <div v-if="getSecondSubscriptionDiscount(selectedPeriod) > 0" class="second-sub-notice plan-detail-notice">
                  <strong>2a assinatura com {{ getSecondSubscriptionDiscount(selectedPeriod) }}% de desconto</strong>
                  <span>Para quem já possui assinatura ativa. A validade será a mesma da assinatura principal.</span>
                </div>
                <div class="plan-detail-price">
                  <template v-if="(!showUsd || (showUsd && !(selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0))) && selectedPeriod.price != null && selectedPeriod.price > 0">
                    <span v-if="selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed')" class="price-original">R$ {{ formatPrice(selectedPeriod.price) }}</span>
                    <span class="price-amount">R$ {{ formatPrice(selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed') ? promotionPrice(selectedPeriod) : selectedPeriod.price) }}</span>
                  </template>
                  <template v-if="showUsd && selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0">
                    <span v-if="selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed')" class="price-original">US$ {{ formatPriceUsd(selectedPeriod.priceUsd) }}</span>
                    <span class="price-amount">US$ {{ formatPriceUsd(selectedPeriod.promotion && (selectedPeriod.type === 'percent' || selectedPeriod.type === 'fixed') ? promotionPriceUsd(selectedPeriod) : selectedPeriod.priceUsd) }}</span>
                  </template>
                </div>
                <p v-if="getSecondSubscriptionDiscount(selectedPeriod) > 0" class="plan-detail-second-price">
                  <template v-if="(!showUsd || !(selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0)) && selectedPeriod.price != null && selectedPeriod.price > 0">
                    Na 2a assinatura: <strong>R$ {{ formatPrice(secondSubscriptionPriceBrl(selectedPeriod)) }}</strong>
                  </template>
                  <template v-else-if="showUsd && selectedPeriod.priceUsd != null && selectedPeriod.priceUsd > 0">
                    Na 2a assinatura: <strong>US$ {{ formatPriceUsd(secondSubscriptionPriceUsd(selectedPeriod)) }}</strong>
                  </template>
                </p>
                <p v-if="selectedPeriod.promotion && selectedPeriod.expiration" class="plan-detail-validity">Válido até {{ selectedPeriod.expiration }}</p>
                <ul class="plan-detail-features">
                  <li>Acesso conforme período</li>
                  <li>Indicadores Swiss</li>
                  <li>Suporte Premium</li>
                </ul>
                <button type="button" class="btn btn-primary plan-detail-button" @click="openUserLogin">Assine agora e entre para o Club</button>
              </div>
              <div v-else class="plan-detail-empty">
                <p>Selecione um período ao lado.</p>
              </div>
            </div>
          </div>
        </template>
      </div>
    </section>

    <!-- Feedbacks -->
    <section id="feedbacks" class="feedbacks-section section-block">
      <div class="container">
        <div class="section-head">
          <p class="section-kicker">Comunidade</p>
          <h2 class="section-title">Feedback da comunidade</h2>
          <p class="section-subtitle">Swiss é vida.</p>
          <p class="section-description">Resultados reais de quem vive a nossa metodologia.</p>
        </div>
        <div class="feedbacks-carousel-wrapper">
          <swiper :options="feedbacksSwiperOption" class="feedbacks-swiper">
            <swiper-slide v-for="i in 9" :key="i" class="feedback-slide">
              <div class="feedback-item">
                <img :src="`/img/depo-${i}.png`" alt="Depoimento" class="feedback-image" />
              </div>
            </swiper-slide>
          </swiper>
          <div class="feedbacks-pagination"></div>
        </div>
      </div>
    </section>

    <!-- Assinantes -->
    <section class="subscribers-section section-block section-block--alt">
      <div class="container">
        <div class="section-head">
          <p class="section-kicker">Membros</p>
          <h2 class="section-title">Área de assinantes</h2>
          <p class="section-subtitle">Uma experiência única</p>
        </div>
        <button type="button" class="btn btn-primary btn-lg" @click="openUserLogin">Entre para o Club Swiss</button>
        <div class="subscribers-features">
          <div class="feature-item" data-aos="fade-up">
            <h3 class="feature-title">Ferramentas de Precisão</h3>
            <p class="feature-description">Soluções Exclusivas para Traders Premium</p>
          </div>
          <div class="feature-item" data-aos="fade-up" data-aos-delay="100">
            <h3 class="feature-title">Conteúdo Exclusivo</h3>
            <ul class="feature-list">
              <li>Lives ao vivo diariamente B3 + Mercado Internacional</li>
              <li>Salas de Estudos / Análises</li>
              <li>Ambiente Educacional com especialistas</li>
              <li>Suporte qualificado + Educadores Experientes</li>
            </ul>
          </div>
        </div>
        <div class="lives-section" data-aos="fade-up">
          <img src="/img/swiss-banner-lives.jpg" alt="Lives ao Vivo" class="lives-banner" />
        </div>
      </div>
    </section>

    <!-- CTA Final Section -->
    <section class="cta-section">
      <div class="container">
        <h2 class="cta-title">O Trading é para todos.<br>O sucesso é apenas para quem escolhe o caminho certo. Swiss Money: Seu caminho. Sua direção. Seu sucesso</h2>
      </div>
    </section>

    <!-- Contato Section -->
    <section class="contact-section">
      <div class="container">
        <h3 class="contact-title">Contato</h3>
        <div class="contact-telegram" @click="gotoTelegram">
          <img src="/img/telegram.png" alt="Telegram Suporte" class="telegram-icon" />
          <span>Telegram Suporte</span>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import AOS from 'aos'
import 'aos/dist/aos.css'
import { getGrouped } from '../../admin/api/product'
import { getGeo } from '../api/geo'
import logger from '../../logger'

const PLATFORM_CAROUSEL_ITEMS = [
  { name: 'TradingView', img: '/img/logo-tv.png' },
  { name: 'NinjaTrader', img: '/img/logo-nt.png' },
  { name: 'Profit', img: '/img/logo-profit.png' },
  { name: 'BlackArrow', img: '/img/logo-ba.png' }
]

export default {
  name: 'main',
  props: ['businessUrl', 'new'],
  created () {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    })
  },
  data () {
    return {
      API_IMG: process.env.VUE_APP_IMG,
      products: [],
      selectedPlatformIndex: 0,
      selectedPeriodIndex: 0,
      userCountry: null,
      countdown: {
        days: '00',
        hours: '00',
        minutes: '00',
        seconds: '00'
      },
      countdownInterval: null,
      targetDate: new Date('2024-12-31T23:59:59'),
      platformCarouselCount: PLATFORM_CAROUSEL_ITEMS.length,
      feedbacksSwiperOption: {
        loop: true,
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: false,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.feedbacks-pagination',
          clickable: true
        },
        breakpoints: {
          480: { slidesPerView: 2, spaceBetween: 20 },
          768: { slidesPerView: 2, spaceBetween: 24 },
          1024: { slidesPerView: 3, spaceBetween: 30 }
        }
      }
    }
  },
  computed: {
    ...mapState(['showLogin', 'reload', 'user']),
    activeProducts () {
      return (this.products || []).filter(p => p.active)
    },
    selectedProduct () {
      if (!this.activeProducts.length) return null
      const i = Math.min(this.selectedPlatformIndex, this.activeProducts.length - 1)
      return this.activeProducts[i]
    },
    selectedPeriod () {
      const prod = this.selectedProduct
      if (!prod || !prod.periods || !prod.periods.length) return null
      const i = Math.min(this.selectedPeriodIndex, prod.periods.length - 1)
      return prod.periods[i]
    },
    showUsd () {
      return this.userCountry && this.userCountry !== 'BR'
    },
    platformsMarqueeSlides () {
      return [...PLATFORM_CAROUSEL_ITEMS, ...PLATFORM_CAROUSEL_ITEMS]
    }
  },
  mounted () {
    this.getData()
    getGeo().then(r => { this.userCountry = r.country }).catch(() => {})
    document.body.style.backgroundColor = '#0b0e11'
    this.startCountdown()
  },
  beforeDestroy () {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
  },
  methods: {
    async getData () {
      try {
        this.products = await getGrouped()
      } catch (error) {
        logger.error(error, this)
      }
    },
    formatPrice (price) {
      if (price == null) return '0,00'
      return Number(price).toLocaleString('pt-br', { minimumFractionDigits: 2 })
    },
    formatPriceUsd (price) {
      if (price == null) return '0.00'
      return Number(price).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    platformLabel (platform) {
      const labels = {
        profit: 'Profit',
        blackarrow: 'BlackArrow',
        ninjatrader: 'NinjaTrader',
        tradingview: 'TradingView',
        profit_yan: 'Profit Yan',
        blackarrow_yan: 'BlackArrow Yan',
        ninjatrader_yan: 'NinjaTrader Yan'
      }
      return labels[platform] || platform || ''
    },
    platformLogo (platform) {
      const logos = {
        profit: '/img/logo-profit.png',
        profit_yan: '/img/logo-profit.png',
        tradingview: '/img/logo-tv.png',
        ninjatrader: '/img/logo-nt.png',
        ninjatrader_yan: '/img/logo-nt.png',
        blackarrow: '/img/logo-ba.png',
        blackarrow_yan: '/img/logo-ba.png'
      }
      return logos[platform] || null
    },
    promotionPrice (per) {
      const price = Number(per.price) || 0
      const discount = Number(per.discount) || 0
      if (per.type === 'percent') return Math.max(0, price * (1 - discount / 100))
      if (per.type === 'fixed') return Math.max(0, price - discount)
      return price
    },
    promotionPriceUsd (per) {
      const priceUsd = Number(per.priceUsd) || 0
      const discount = Number(per.discount) || 0
      if (per.type === 'percent') return Math.max(0, priceUsd * (1 - discount / 100))
      if (per.type === 'fixed') return Math.max(0, priceUsd - discount)
      return priceUsd
    },
    getSecondSubscriptionDiscount (per) {
      if (!per) return 0
      const v = per.secondSubscriptionDiscount != null
        ? per.secondSubscriptionDiscount
        : per.second_subscription_discount
      return Math.min(100, Math.max(0, parseInt(v) || 0))
    },
    periodPriceBrl (per) {
      if (!per) return 0
      if (per.promotion && (per.type === 'percent' || per.type === 'fixed')) return this.promotionPrice(per)
      return Number(per.price) || 0
    },
    periodPriceUsd (per) {
      if (!per) return 0
      if (per.promotion && (per.type === 'percent' || per.type === 'fixed')) return this.promotionPriceUsd(per)
      return Number(per.priceUsd) || 0
    },
    secondSubscriptionPriceBrl (per) {
      const base = this.periodPriceBrl(per)
      const pct = this.getSecondSubscriptionDiscount(per)
      return Math.round(base * (100 - pct)) / 100
    },
    secondSubscriptionPriceUsd (per) {
      const base = this.periodPriceUsd(per)
      const pct = this.getSecondSubscriptionDiscount(per)
      return Math.round(base * (100 - pct)) / 100
    },
    startCountdown () {
      this.countdownInterval = setInterval(() => {
        const now = new Date().getTime()
        const distance = this.targetDate.getTime() - now

        if (distance > 0) {
          this.countdown.days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0')
          this.countdown.hours = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, '0')
          this.countdown.minutes = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, '0')
          this.countdown.seconds = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, '0')
        } else {
          this.countdown.days = '00'
          this.countdown.hours = '00'
          this.countdown.minutes = '00'
          this.countdown.seconds = '00'
        }
      }, 1000)
    },
    scrollToSection (sectionId) {
      const element = document.getElementById(sectionId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    gotoTelegram () {
      window.open('https://t.me/SuporteSwissMoney', '_blank')
    },
    openUserLogin () {
      if (this.user) {
        this.$router.push('/usuario')
      } else {
        this.$store.commit('showLogin', true)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";
@import "../_asset/scss/landing-page";
</style>
